// extracted by mini-css-extract-plugin
module.exports = {"close_button":"ModalHeader_close_button__nFjWi","header_container":"ModalHeader_header_container__OLkvj","back_button":"ModalHeader_back_button__Watyv"};